import React, {Fragment} from "react";
import Sidebar from "../../components/Sidebar";
import NsAccordion from "../../components/accordion/NsAccordion";
import {Tab, Tabs} from "react-bootstrap";
import ContenutoArchivioController from "./components/ContenutoArchivioController";
import ContenutoTitoliArchivioController from "./components/ContenutoTitoliArchivioController";
import ModalConfirm from "../../components/ModalConfirm";
import ModalAddTitoloArchivio from "./components/ModalAddTitoloArchivio";
import ModalFiltroArchivio from "./components/ModalFiltroArchivio";
import NsBreadcrumbs from "../../components/NsBreadcrumbs";

export default function ArchivioModelliView({
                                                idMarca,
                                                marca,
                                                temi,
                                                titoli,
                                                titoloSel,
                                                getAlberoStruttura,
                                                isMobile,
                                                keyTab,
                                                setKeyTab,
                                                keyTabSottotemi,
                                                setKeyTabSottotemi,
                                                handlerRefreshTabs,
                                                handlerRefreshTitoli,
                                                selectTitolo,
                                                clearFiltroPagina,
                                                titoloToDelete,
                                                eliminaTitolo,
                                                showConfirmDelTitolo,
                                                setShowConfirmDelTitolo,
                                                idTitoloUpdate,
                                                showModalUpdateTitolo,
                                                closeModalUpdateTitolo,
                                                updateTitoloOk,
                                                handlerModificaTitolo,
                                                handlerEliminaTitolo,
                                                isAdmin,
                                                showModalFiltri,
                                                setShowModalFiltri,
                                                numFiltroArchivio,
                                                getTitoloSottotema,
                                                goBack,
                                                handleClickBreadcrumbs,
                                            }) {

    return (
        <Fragment>
            <ModalFiltroArchivio
                show={showModalFiltri}
                handleClose={() => setShowModalFiltri(false)}
                submitOk={() => {
                    setShowModalFiltri(false);
                }}
            />
            <ModalConfirm
                show={showConfirmDelTitolo}
                handleClose={() => setShowConfirmDelTitolo(false)}
                handleOk={() => {
                    eliminaTitolo();
                    setShowConfirmDelTitolo(false);
                }}
                testo={"Sicuro di voler eliminare il titolo: " + (titoloToDelete && titoloToDelete.titolo) + "?"}
            />
            <ModalAddTitoloArchivio
                idMarca={idMarca}
                marca={marca}
                idTitolo={idTitoloUpdate}
                show={showModalUpdateTitolo}
                handleClose={closeModalUpdateTitolo}
                submitOk={updateTitoloOk}
            />
            <div className={"container-fluid pt-3"}>
                <Fragment>
                    <Sidebar
                        sidebarContent={() => {
                            return isMobile ?
                                <NsAccordion
                                    titolo={'Struttura kpi'}
                                    label={'fas fa-stream'}>
                                    {
                                        getAlberoStruttura()
                                    }
                                </NsAccordion>
                                : getAlberoStruttura()
                        }}
                    >
                        <div className={'row'}>
                            <div className={'col-md-2'}>
                            </div>
                            <div className={'col-md-8'}>
                                {
                                    titoloSel ?
                                        <h4 className={"text-center"}>{`${titoloSel.marca} ${titoloSel.modello}`}</h4>
                                        :
                                        <h4 className={"text-center"}>{marca && marca.marca}</h4>
                                }
                            </div>
                            <div className={'col-md-2 text-end'}>
                                {
                                    isAdmin && titoloSel &&
                                    <Fragment>
                                        <button
                                            type={'button'}
                                            className={'btn btn-dark btn-sm'}
                                            data-toggle="tooltip" title="Modifica"
                                            onClick={handlerModificaTitolo}
                                        >
                                            <i className="fas fa-edit"/>
                                        </button>
                                        <button
                                            type={'button'}
                                            className={'btn btn-dark btn-sm'}
                                            data-toggle="tooltip" title="Elimina"
                                            onClick={handlerEliminaTitolo}
                                        >
                                            <i className="fas fa-trash"/>
                                        </button>
                                    </Fragment>
                                }
                                <button
                                    type={'button'}
                                    className={'btn btn-principal btn-sm'}
                                    data-toggle="tooltip" title="Filtri"
                                    onClick={() => setShowModalFiltri(true)}
                                >
                                    <i className="fas fa-filter"/> {numFiltroArchivio > 0 ? numFiltroArchivio : ''}
                                </button>
                            </div>
                        </div>
                        <hr className={"dropdown-divider"}/>
                        <NsBreadcrumbs
                            handleClick={handleClickBreadcrumbs}
                        />
                        {
                            titoloSel ?
                                <Fragment>
                                    <Tabs
                                        id="temi"
                                        activeKey={keyTab}
                                        onSelect={(k) => {
                                            setKeyTab(k);

                                            const arrTemiFiltrati = temi.filter(t => t.codice === k);
                                            if (arrTemiFiltrati.length > 0 && arrTemiFiltrati[0].sottotemi && arrTemiFiltrati[0].sottotemi !== '') {
                                                setKeyTabSottotemi(arrTemiFiltrati[0].sottotemi.split(';')[0]);
                                            }
                                        }}
                                        className="mb-3"
                                    >
                                        {
                                            temi.map(tema =>
                                                <Tab
                                                    key={tema.codice}
                                                    eventKey={tema.codice}
                                                    title={`${tema.tema} (${tema.num_documenti})`}
                                                    mountOnEnter={true}
                                                    unmountOnExit={true}
                                                >
                                                    {
                                                        tema.sottotemi && tema.sottotemi !== '' ?
                                                            <Tabs
                                                                id="sottotemi"
                                                                activeKey={keyTabSottotemi}
                                                                onSelect={(k) => setKeyTabSottotemi(k)}
                                                                className="mb-3"
                                                            >
                                                                {
                                                                    tema.sottotemi.split(';').map(sottotema =>
                                                                        <Tab
                                                                            key={sottotema}
                                                                            eventKey={sottotema}
                                                                            title={getTitoloSottotema(tema, sottotema)}
                                                                            mountOnEnter={true}
                                                                            unmountOnExit={true}
                                                                        >
                                                                            <ContenutoArchivioController
                                                                                titolo={titoloSel}
                                                                                tema={tema}
                                                                                sottotema={sottotema}
                                                                                handlerRefreshTabs={handlerRefreshTabs}
                                                                            />
                                                                        </Tab>)
                                                                }
                                                            </Tabs>
                                                            :
                                                            <ContenutoArchivioController
                                                                titolo={titoloSel}
                                                                tema={tema}
                                                                handlerRefreshTabs={handlerRefreshTabs}
                                                            />
                                                    }
                                                </Tab>)
                                        }
                                    </Tabs>
                                </Fragment>
                                :
                                <ContenutoTitoliArchivioController
                                    idMarca={idMarca}
                                    titoli={titoli}
                                    handlerRefreshTitoli={handlerRefreshTitoli}
                                    selectTitolo={selectTitolo}
                                />
                        }
                    </Sidebar>
                </Fragment>
            </div>
        </Fragment>
    );
}